import { Link } from 'react-router-dom';

export default function NotFound() {
  return (
    <div className="page" style={{ alignItems: 'center', justifyContent: 'center', textAlign: 'center' }}>
      <div className="container">
        <h1 style={{
          fontFamily: 'var(--font-heading)',
          fontSize: 'clamp(4rem, 15vw, 8rem)',
          color: 'var(--mid-color)',
          lineHeight: 1,
          marginBottom: 8,
        }}>
          404
        </h1>
        <h2 style={{ fontFamily: 'var(--font-heading)', color: 'var(--text-muted)', marginBottom: 16 }}>
          Deeply, profoundly mid.
        </h2>
        <p className="text-muted mb-32" style={{ fontSize: '0.9rem' }}>
          This page does not exist.<br />
          The internet has no opinion on it.
        </p>
        <Link to="/">
          <button className="btn-primary" style={{ width: 'auto', padding: '12px 32px' }}>
            Go home
          </button>
        </Link>
      </div>
    </div>
  );
}
